import { render, staticRenderFns } from "./TopicGridItem.vue?vue&type=template&id=702a39f7&"
import script from "./TopicGridItem.vue?vue&type=script&lang=js&"
export * from "./TopicGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports